export default __webpack_public_path__ + "static/media/greendark.5ed534d5.svg";